var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnarchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unarchive_FILL0_wght400_GRAD0_opsz48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unarchive-lists",
    transform: "translate(-1041.000000, -446.000000)",
    fill: "#8892B0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(1023.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unarchive_FILL0_wght400_GRAD0_opsz48",
    transform: "translate(18.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25,15 C0.916666667,15 0.625,14.875 0.375,14.625 C0.125,14.375 0,14.0833333 0,13.75 L0,2.85416667 C0,2.64583333 0.0208333333,2.46875 0.0625,2.32291667 C0.104166667,2.17708333 0.180555556,2.04166667 0.291666667,1.91666667 L1.45833333,0.333333333 C1.56944444,0.208333333 1.69791667,0.121527778 1.84375,0.0729166667 C1.98958333,0.0243055556 2.15972222,0 2.35416667,0 L12.6458333,0 C12.8402778,0 13.0069444,0.0243055556 13.1458333,0.0729166667 C13.2847222,0.121527778 13.4097222,0.208333333 13.5208333,0.333333333 L14.7083333,1.91666667 C14.8194444,2.04166667 14.8958333,2.17708333 14.9375,2.32291667 C14.9791667,2.46875 15,2.64583333 15,2.85416667 L15,13.75 C15,14.0833333 14.875,14.375 14.625,14.625 C14.375,14.875 14.0833333,15 13.75,15 L1.25,15 Z M1.60416667,2.20833333 L13.375,2.20833333 L12.625,1.25 L2.35416667,1.25 L1.60416667,2.20833333 Z M1.25,3.45833333 L1.25,13.75 L13.75,13.75 L13.75,3.45833333 L1.25,3.45833333 Z M6.875,11.875 L8.125,11.875 L8.125,7.6875 L9.91666667,9.47916667 L10.75,8.64583333 L7.5,5.39583333 L4.25,8.64583333 L5.08333333,9.47916667 L6.875,7.6875 L6.875,11.875 Z M1.25,13.75 L13.75,13.75 L1.25,13.75 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.2545e7e9e1cf69f3fb3994f39f473141.svg";
export { ForwardRef as ReactComponent };